import PlanApi from "@/components/Api/PlanApi"
import { Message } from 'element-ui';

/**
 * 行程轴名称拼接显示
 * @param cityList 当天内的城市数据
 * @param symbolCode 拼接符 如：-，/ 等等
 */
export const citySplicing = function (cityList,symbolCode) {
  let cityValue = ""
  cityList.forEach(city => {
    cityValue = cityValue + city.cityName + symbolCode
  })
  if (cityValue.indexOf(symbolCode) !== -1) {
    cityValue = cityValue.slice(0,cityValue.length-1)
  }
  return cityValue;
}

/**
 * Toc 的行程轴数据整合
 * @param {*} params  {planId: "",budgetMainId: ""}
 */
export const changePlanInfo = async function (params) {
  return new Promise((pro) => {
    Promise.all([getPlanDay(params),getBudgetList(params.budgetMainId)]).then(resAry => { 
      let platDays = resAry[0]
      let budgets = resAry[1]
      let _platDays = []
      platDays.budgetMain.planDayList.forEach(item => {
        let _planDay = {}
        _planDay.planDay = item.planDay
        _planDay.planDate = item.planDate
        _planDay.planId = item.planId
        _planDay.cityStr = citySplicing(item.cityList,"-")
        _planDay.cityList = item.cityList
        let _filterBudgets = budgets.filter(x => x.day == item.planDay)
        var budgetListArr = []
        _filterBudgets.forEach(bud => {
          let startHours = new Date(bud.stayDate).getHours() || "00";
          let startMinutes = new Date(bud.stayDate).getMinutes() || "00";
          let endHours = new Date(bud.endStayDate).getHours()|| "00";
          let endMinutes = new Date(bud.endStayDate).getMinutes()|| "00";
          let start = startHours + ":" + startMinutes
          let end = endHours + ":" + endMinutes
          let _budgetList = {}
          
          if (start !== "00:00" && end !== "00:00") {
            _budgetList.timeStr = start + "-" + end
          }
          let resourceDetail = bud.resourceDetail ? JSON.parse(bud.resourceDetail) : {}
          _budgetList.day = bud.day
          _budgetList.resourceNameCn = bud.resourceNameCn
          _budgetList.imageUrl = resourceDetail.imageUrl
          _budgetList.introduction = resourceDetail.introduction
          _budgetList.addressCn = resourceDetail.addressCn
          _budgetList.state = bud.state
          _budgetList.star = resourceDetail.star
          let stockDetail = []
          if (bud.details.length > 0) {
            _budgetList.totalPrice = bud.details.map(de => de.ratio*de.stockNumber).reduce((n,m) => n + m)
            _budgetList.currency = bud.details[0].currency
            bud.details.forEach(budDetails => {
              let detail = JSON.parse(budDetails.stockDetail)
              let _stockDetail = {}
              _stockDetail.budgetType = detail.budgetType
              _stockDetail.timeDesc = detail.priceList[0].timeDesc
              _stockDetail.productNameCn = detail.productNameCn
              _stockDetail.priceCompany = detail.priceList[0].priceCompany
              _stockDetail.useTime = detail.priceList[0].useTime
              _stockDetail.ratio = budDetails.ratio
              _stockDetail.stockDesc = detail.stockDesc
              _stockDetail.currency = budDetails.currency
              _stockDetail.stockNumber = budDetails.stockNumber
              _stockDetail.productDesc = detail.productDesc
              stockDetail.push(_stockDetail)
            })
          }
          _budgetList.stockDetail = stockDetail
          budgetListArr.push(_budgetList)        
          _planDay.budgetList = budgetListArr
        })
        _platDays.push(_planDay)
      })
      console.log('asdasdasd',_platDays)
      pro(_platDays)
    }).catch((err) => { 
      Message({ type: 'info', message: err }); 
    })
  })
}

function getPlanDay(params) {
  return new Promise(res => {
    new PlanApi("plan").planDetail(params).then((result) => {
      if (result.status == 200) {
        res(result.data)
      }
    }).catch((err) => {
      Notify({ type: 'danger', message: '系统异常！' });
    });
  })
}

async function getBudgetList(budgetMainId) {
  return new Promise(res => {
    new PlanApi("plan").budgetList({budgetMainId: budgetMainId}).then((result) => {
      if (result.status == 200) {
         res(result.data)
      }
    }).catch((err) => {
      Notify({ type: 'danger', message: '系统异常！' });
    });
  })
}
